import { atom } from "recoil";
import { AddressProps } from "../../components/address-input/address-props";
export const personalAdressState = atom<AddressProps | null>({
  key: "personalAdressState",
  default: null,
});
